import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'userstar', 
  templateUrl: 'userstar.html',
}) 

export class UserStarComponent{

  @Input('percent') percent:number; 
  @Input('startcolor') startcolor:string; 
  @Input('endcolor') endcolor:string; 
  @Input('strokecolor') strokecolor:string; 
  percentuale:any;
  rand:any;
  constructor(public events: Events) {
  }
  update_output(){
  //  this.events.publish('aperta', this.domanda, this.risp);
  }
  ngOnInit(){
   
   //this.percentuale = 500 /100 *(100-this.percent);
   
    this.percentuale = 500-(500/100*this.percent);
    this.rand = 'asd'+Math.floor(Math.random() * 1000);
  } 
}



// WEBPACK FOOTER //
// ./src/pages/component/userstar.ts